// Atoms
import VmButton from './atoms/vm-button/vm-button';
import VmButtonLink from './atoms/vm-button-link/vm-button-link';
import VmIcon from './atoms/vm-icon/vm-icon';
import VmVideoChapter from './atoms/vm-video-chapter/vm-video-chapter';

// Molecules
import VmSlider from './molecules/vm-slider/vm-slider';
import VmVideoCommentsList from './molecules/vm-video-comments-list/vm-video-comments-list';
import VmVideoCommentsListItem from './molecules/vm-video-comments-list-item/vm-video-comments-list-item';

// Organisms
import VmVideoChapters from './organisms/vm-video-chapters/vm-video-chapters';
import VmVideoComments from './organisms/vm-video-comments/vm-video-comments';

import VmChatbotLoader from './vm-chatbot-loader/vm-chatbot-loader';
import VmChatbotSkeleton from './vm-chatbot-skeleton/vm-chatbot-skeleton';

import VmListPagination from './vm-list-pagination/vm-list-pagination';
import VmSortDropdown from './vm-sort-dropdown/vm-sort-dropdown';
import VmLoadingSpinner from './vm-loading-spinner/vm-loading-spinner';
import VmProfileImage from './vm-profile-image/vm-profile-image';

import VmKolProfilePage from './vm-kol-profile-page/vm-kol-profile-page';
import VmKolProfilePageHeader from './vm-kol-profile-page-header/vm-kol-profile-page-header';
import VmKolProfilePageVideoList from './vm-kol-profile-page-video-list/vm-kol-profile-page-video-list';
import VmKolProfilePageVideoListItem from './vm-kol-profile-page-video-list-item/vm-kol-profile-page-video-list-item';

// Atoms
customElements.define('vm-button', VmButton);
customElements.define('vm-button-link', VmButtonLink);
customElements.define('vm-icon', VmIcon);
customElements.define('vm-video-chapter', VmVideoChapter);

// Molecules
customElements.define('vm-slider', VmSlider);
customElements.define('vm-video-comments-list', VmVideoCommentsList);
customElements.define('vm-video-comments-list-item', VmVideoCommentsListItem);

// Organisms
customElements.define('vm-video-chapters', VmVideoChapters);
customElements.define('vm-video-comments', VmVideoComments);

customElements.define('vm-chatbot-loader', VmChatbotLoader);
customElements.define('vm-chatbot-skeleton', VmChatbotSkeleton);

customElements.define('vm-list-pagination', VmListPagination);
customElements.define('vm-sort-dropdown', VmSortDropdown);
customElements.define('vm-loading-spinner', VmLoadingSpinner);
customElements.define('vm-profile-image', VmProfileImage);

customElements.define('vm-kol-profile-page', VmKolProfilePage);
customElements.define('vm-kol-profile-page-header', VmKolProfilePageHeader);
customElements.define('vm-kol-profile-page-video-list', VmKolProfilePageVideoList);
customElements.define('vm-kol-profile-page-video-list-item', VmKolProfilePageVideoListItem);
